/** Colunas do Historico de Lancamentos que ordenam (mesmos nomes do backend). */
export type ColunaOrdenavel = 'data' | 'categoria' | 'subCategoria' | 'formaPagamento' | 'valor';

export interface Ordenacao {
    campo: ColunaOrdenavel;
    direcao: 'asc' | 'desc';
}

/** Padrao da tela (MAN-133): sempre pela data do lancamento, mais recente primeiro. */
export const ORDENACAO_PADRAO: Ordenacao = { campo: 'data', direcao: 'desc' };

// Primeiro clique: data e valor do maior para o menor; textos de A a Z;
// tipo com gastos primeiro (GASTOS vem antes de RECEITA).
const DIRECAO_DO_PRIMEIRO_CLIQUE: Record<ColunaOrdenavel, Ordenacao['direcao']> = {
    data: 'desc',
    valor: 'desc',
    categoria: 'asc',
    subCategoria: 'asc',
    formaPagamento: 'asc',
};

export function ehColunaOrdenavel(coluna: string): coluna is ColunaOrdenavel {
    return coluna in DIRECAO_DO_PRIMEIRO_CLIQUE;
}

/** Clique no cabecalho: a mesma coluna inverte o sentido; outra coluna comeca no sentido dela. */
export function proximaOrdenacao(atual: Ordenacao, coluna: ColunaOrdenavel): Ordenacao {
    if (atual.campo === coluna) {
        return { campo: coluna, direcao: atual.direcao === 'asc' ? 'desc' : 'asc' };
    }
    return { campo: coluna, direcao: DIRECAO_DO_PRIMEIRO_CLIQUE[coluna] };
}
